import { render, staticRenderFns } from "./authManagementList.vue?vue&type=template&id=2d4050ac&scoped=true"
import script from "./authManagementList.vue?vue&type=script&lang=js"
export * from "./authManagementList.vue?vue&type=script&lang=js"
import style0 from "./authManagementList.vue?vue&type=style&index=0&id=2d4050ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4050ac",
  null
  
)

export default component.exports